import { FailedToGetData, H2, Loading, TerritoryNumberBlock } from 'src/components/_commons';
import { houseToHouseServices } from 'src/services';
import { setAlertResponse } from '@/store';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetConfig, useGetIsDarkMode } from 'src/custom-hooks';
import { useLocation } from 'react-router';

export const HTHFreeSelectorPage = () => {
    const queryString = new URLSearchParams(useLocation().search);
    //
    const [isLoading, setIsLoading] = useState(true);
    const [territories, setTerritories] = useState<number[] | null>(null);
    const config = useGetConfig();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    //
    const congregation = config.congregation || parseInt(queryString.get('grupo') || '0');

    useEffect(() => {
        if (!congregation) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        houseToHouseServices.GetNumbersOfReleasedTerritories(congregation).then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.numbersOfTerritories) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setTerritories(response.data.numbersOfTerritories);
        });
    }, [congregation]);

    if (!congregation) {
        return (
            <div className={`${isDarkMode ? 'text-white' : ''} text-center`} style={{ marginTop: '80px' }}>
                El enlace es incorrecto
            </div>
        );
    }

    if (isLoading) {
        return <Loading mt={'80px'} />;
    }

    if (!territories) {
        return <FailedToGetData />;
    }

    return (
        <>
        <H2 title={'CASA EN CASA'} mb={'10px'} />
        {/* <HTHVoiceToText congregation={congregation} /> */}
        {!!territories.length ?
            <TerritoryNumberBlock
                classes={'btn-general-blue animate__animated animate__rubberBand'}
                showForecast={true}
                territories={territories.sort((t1, t2) => t1 - t2)}
                url={`/buscador/${congregation}`}
            />
            :
            <h5 className={`${isDarkMode ? 'text-white' : ''} text-center`}>
                No hay territorios compartidos el día de hoy
            </h5>
        }
        </>
    );
}
